import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './shine-buttons.css';
import './dust.css';
import './ui-consistency.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
